/* ===========================================================================
   VATNARA PDP — Verhalten (portiert aus pages/vatnara-pdp-solance/app.js, 11.09.2026)
   ---------------------------------------------------------------------------
   Unterschied zur Vorlage: es gibt kein globales D = window.PDP mehr. Alle Inhalte
   rendern die Sections in Liquid; dieses Skript liest nur noch data-Attribute und
   JSON-<script>-Bloecke aus dem DOM und haengt das Verhalten an:
     Galerie        click   Thumbnails (data-src / data-alt)
     Ad-Match       url     ?angle=… tauscht H1/Unterzeile (#vtAngles JSON) + Anliegen-Tab
     Kauf-Block     click   Plan-Karten (data-plan / data-price / data-variant) → echtes
                            POST /cart/add; Preis in ATC, CTA-Baendern, Sticky-Leiste
     Lieferung      time    Zustellfenster aus data-handling / data-transit
     UGC-Karte      click   Standbild → <video controls>, danach zurueck
     Videos         click   Tabs (data-src / data-poster) + passende Schrittliste
     Anliegen       click   Tabs mit data-* → Bewertungskarte
     Passt-es       click   Typen mit data-* → Urteil
     Bestell-Feed   time    #ofeed (nur gerendert, wenn die Section live=true hat)
     Reveal         scroll  IntersectionObserver
   GHOST-Wächter wie in der Vorlage: fehlende Module rendern ins Leere statt zu werfen.
   =========================================================================== */
(() => {
const GHOST = { innerHTML:"", textContent:"", src:"", alt:"", hidden:true, offsetWidth:0, style:{}, dataset:{}, value:"",
  classList:{ add(){}, remove(){}, toggle(){}, contains(){ return false; } },
  addEventListener(){}, setAttribute(){}, append(){}, insertAdjacentHTML(){}, closest(){ return null; }, querySelector(){ return null; } };
const $  = (s, r=document) => r.querySelector(s) || GHOST;
const $$ = (s, r=document) => (r === GHOST ? [] : [...r.querySelectorAll(s)]);
const qs = new URLSearchParams(location.search);
const esc = s => String(s == null ? "" : s).replace(/[&<>"']/g, c => ({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c]));

/* Sterne mit Teilfuellung — exakt wie Stars.tsx (nur noch fuer die Anliegen-Karte gebraucht) */
function stars(rating, size = 14){
  return [1,2,3,4,5].map(i => {
    const fill = Math.max(0, Math.min(1, rating - i + 1)) * 100;
    const id = `js${i}-${String(rating).replace(".","_")}-${size}`;
    return `<svg width="${size}" height="${size}" viewBox="0 0 20 20" aria-hidden="true">
      <defs><linearGradient id="${id}">
        <stop offset="${fill}%" stop-color="#F0A81C"/>
        <stop offset="${fill}%" stop-color="transparent"/>
      </linearGradient></defs>
      <path d="M10 1.6l2.5 5.4 5.9.7-4.4 4 1.2 5.8L10 14.6l-5.2 2.9L6 11.7l-4.4-4 5.9-.7z"
        fill="url(#${id})" stroke="#F0A81C" stroke-width="1"/></svg>`;
  }).join("");
}

/* --- Ad-Match: ?angle=… tauscht nur Above-the-fold ---------------------------- */
let ANGLE = null;
const anglesEl = document.getElementById("vtAngles");
if (anglesEl){ try { ANGLE = (JSON.parse(anglesEl.textContent || "{}"))[qs.get("angle")] || null; } catch (e) { ANGLE = null; } }
if (ANGLE){ $("#vtH1").textContent = ANGLE.h1 || $("#vtH1").textContent; $("#vtTagline").textContent = ANGLE.tagline || $("#vtTagline").textContent; }

/* --- Galerie -------------------------------------------------------------- */
const main = $("#galMain"), thumbs = $("#galThumbs"), galOv = $("#galOv");
$$(".gal__thumb", thumbs).forEach(b => b.addEventListener("click", () => {
  main.src = b.dataset.src; main.alt = b.dataset.alt || "";
  galOv.innerHTML = b.dataset.ovT ? `<span class="galov__k">${esc(b.dataset.ovK)}</span><b class="galov__t">${esc(b.dataset.ovT)}</b><span class="galov__s">${esc(b.dataset.ovS || "")}</span>` : "";
  $$(".gal__thumb", thumbs).forEach(t => t.setAttribute("aria-current", t === b));
}));

/* --- Kauf-Block: Plan-Karten, echtes Formular ---------------------------------- */
const form = $("#vt-form");
const cards = $$(".buy__card", form);
const variantInput = $("#vt-variant"), planInput = $("#vt-plan");
const starter = qs.get("variant") === "starter";
let plan = starter && cards.some(c => c.dataset.plan === "once") ? "once" : (cards[0] ? cards[0].dataset.plan : null);
const priceNow = () => { const c = cards.find(x => x.dataset.plan === plan) || cards[0]; return c ? (c.dataset.price || "") : ""; };
function renderBuy(){
  cards.forEach(c => {
    const on = c.dataset.plan === plan;
    c.classList.toggle("buy__card--active", on);
    const r = c.querySelector(".vradio"); if (r) r.classList.toggle("vradio--on", on);
    const body = c.querySelector(".buy__body"); if (body) body.hidden = !on;
    if (starter && c.dataset.plan !== "once") c.style.display = "none";
  });
  const c = cards.find(x => x.dataset.plan === plan);
  if (c){
    if (c.dataset.variant && variantInput !== GHOST) variantInput.value = c.dataset.variant;
    if (planInput !== GHOST) planInput.value = c.dataset.title || "";
  }
  $$("[data-cta-price]").forEach(n => { n.textContent = priceNow(); });
}
cards.forEach(c => c.addEventListener("click", () => { if (plan === c.dataset.plan) return; plan = c.dataset.plan; renderBuy(); }));
if (cards.length) renderBuy();
/* CTA-Baender + Sticky-Leiste springen zum Kaufblock */
$$("[data-scroll-buy]").forEach(b => b.addEventListener("click", () => {
  const t = document.querySelector("#buy"); if (t) t.scrollIntoView({ behavior:"smooth", block:"start" });
}));

/* --- Bestell-Meldungen (Section rendert #ofeed nur bei live=true) --------------- */
const feed = document.getElementById("ofeed");
if (feed){
  let items = [];
  try { items = JSON.parse((feed.querySelector("script") || {}).textContent || "[]"); } catch (e) { items = []; }
  if (items.length){
    const every = +feed.dataset.every || 14000, first = +feed.dataset.first || 6000;
    let oi = 0;
    const show = () => {
      const o = items[oi % items.length]; oi++;
      feed.innerHTML = `<div class="ofeed__card"><span class="ofeed__dot"></span><div><b>${esc(o.who)}</b> ${esc(o.what)}<span class="ofeed__ago">${esc(o.ago)}</span></div></div>`;
      feed.classList.add("is-on"); setTimeout(() => feed.classList.remove("is-on"), 6000);
    };
    setTimeout(() => { show(); setInterval(show, every); }, first);
  }
}

/* --- Lieferversprechen: Zustellfenster (Countdown nur, wenn data-cutoff-hour gesetzt) --- */
const deliver = $(".deliver");
if (deliver !== GHOST){
  const DAY = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
  const MON = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
  const cutoffHour = deliver.dataset.cutoffHour === "" || deliver.dataset.cutoffHour == null ? null : +deliver.dataset.cutoffHour;
  const timeZone = deliver.dataset.tz || "America/New_York";
  const cutoffLabel = deliver.dataset.cutoffLabel || "";
  const handlingDays = +deliver.dataset.handling || 3;
  const transit = (deliver.dataset.transit || "4,9").split(",").map(Number);
  function zoneParts(date){
    const f = new Intl.DateTimeFormat("en-US",{ timeZone, hour12:false, year:"numeric", month:"2-digit", day:"2-digit", hour:"2-digit", minute:"2-digit", second:"2-digit", weekday:"short" });
    const p = Object.fromEntries(f.formatToParts(date).map(x => [x.type, x.value]));
    return { y:+p.year, m:+p.month, d:+p.day, H:+(p.hour === "24" ? "0" : p.hour), M:+p.minute, S:+p.second, wd:DAY.indexOf(p.weekday) };
  }
  const isBiz = d => d.getUTCDay() !== 0 && d.getUTCDay() !== 6;
  function addBizDays(from, n){ const d = new Date(from); let left = n; while (left > 0){ d.setUTCDate(d.getUTCDate()+1); if (isBiz(d)) left--; } return d; }
  const fmtDay = d => `${DAY[d.getUTCDay()]}, ${MON[d.getUTCMonth()]} ${d.getUTCDate()}`;
  function promise(){
    const now = new Date(), p = zoneParts(now);
    const today = new Date(Date.UTC(p.y, p.m-1, p.d));
    const secsNow = p.H*3600 + p.M*60 + p.S;
    const cutoff  = (cutoffHour == null ? 0 : cutoffHour) * 3600;
    const businessToday = isBiz(today);
    const shipsToday = businessToday && secsNow < cutoff;
    const ship = cutoffHour == null ? addBizDays(today, handlingDays) : (shipsToday ? today : addBizDays(today, 1));
    const [lo, hi] = transit;
    return { remaining: Math.max(0, cutoff - secsNow), shipsToday, shipLabel: fmtDay(ship), deliveryLabel: `${fmtDay(addBizDays(ship, lo))} – ${fmtDay(addBizDays(ship, hi))}` };
  }
  const pad = n => String(n).padStart(2,"0");
  const fmtLeft = s => `${pad(Math.floor(s/3600))}:${pad(Math.floor(s%3600/60))}:${pad(s%60)}`;
  const icon = { bag: $("#deliverIcons [data-icon='bag']").innerHTML, truck: $("#deliverIcons [data-icon='truck']").innerHTML, box: $("#deliverIcons [data-icon='box']").innerHTML };
  function tickDelivery(){
    const s = promise();
    $("#deliverLine").innerHTML = cutoffHour == null
      ? `Ships within ${handlingDays} business days — with you by <b>${s.deliveryLabel}</b>`
      : s.remaining > 0
      ? `Order within <span class="mono" style="color:var(--ink)">${fmtLeft(s.remaining)}</span> and it ships ${s.shipsToday ? "today" : `on ${s.shipLabel}`} — with you by <b>${s.deliveryLabel}</b>`
      : `Orders placed before ${esc(cutoffLabel)} on a business day ship the same day — next dispatch ${s.shipLabel}, with you by <b>${s.deliveryLabel}</b>`;
    $("#deliverSteps").innerHTML = [
      { ic:"bag",   t:"Ordered",   d:"Today" },
      { ic:"truck", t:"Shipped",   d:s.shipLabel },
      { ic:"box",   t:"Delivered", d:s.deliveryLabel }
    ].map(st => `<li class="deliver__step"><span class="deliver__ic">${icon[st.ic] || ""}</span><span class="deliver__t">${st.t}</span><span class="deliver__d">${st.d}</span></li>`).join("");
  }
  tickDelivery(); if (cutoffHour != null) setInterval(tickDelivery, 1000);
}

/* --- UGC-Karten ----------------------------------------------------------- */
/* Axis 31b: ?variant=argument blendet die drei Clips unter dem Kaufblock aus (Kell K17) */
if (qs.get("variant") === "argument"){ const w = document.getElementById("ugcWrap"); if (w) w.hidden = true; }
document.addEventListener("click", e => {
  const btn = e.target.closest(".ugc__play"); if (!btn) return;
  const fig = btn.closest(".ugc"), src = fig.dataset.src;
  if (!src || src === "undefined") return;
  const img = fig.querySelector("img"); const poster = img ? img.src : "";
  fig.dataset.orig = fig.innerHTML;
  fig.innerHTML = `<video src="${esc(src)}" poster="${esc(poster)}" controls playsinline preload="none"></video>`;
  const v = fig.querySelector("video");
  requestAnimationFrame(() => { const p = v.play(); if (p && p.catch) p.catch(() => {}); });
  v.addEventListener("ended", () => { fig.innerHTML = fig.dataset.orig; });
});

/* --- Videos: Install + Kartuschenwechsel ------------------------------------- */
const vidSec = $(".vid"), vidTabs = $("#vidTabs", vidSec), vidStage = $("#vidStage", vidSec);
const vidBtns = $$(".vid__tab", vidTabs), vidLists = $$(".vid__steps", vidSec);
function showVid(i){
  const b = vidBtns[i]; if (!b) return;
  vidStage.innerHTML = `<video src="${esc(b.dataset.src)}" poster="${esc(b.dataset.poster)}" controls playsinline muted preload="metadata"></video>`;
  vidLists.forEach((ol, j) => { ol.hidden = j !== i; });
  vidBtns.forEach((t, j) => t.setAttribute("aria-selected", j === i));
}
vidBtns.forEach((b, i) => b.addEventListener("click", () => showVid(i)));
if (vidBtns.length) showVid(0);

/* --- Anliegen — Tabs tragen ihre Karte als data-* ---------------------------------
   A/B: ?variant=hair entfernt die Haut-Tabs (Test "nur Haar" gegen "Haar + Haut"). */
const hairOnly = qs.get("variant") === "hair";
const concTabs = $("#concTabs");
if (hairOnly) $$(".conc__tab--skin", concTabs).forEach(t => t.remove());
const concBtns = $$(".conc__tab", concTabs);
function showConcern(i){
  const t = concBtns[i]; if (!t) return; const d = t.dataset;
  $("#concH").textContent = d.h || ""; $("#concP").textContent = d.p || ""; $("#concP").style.display = "";
  $("#concStat").style.display = "none";
  const rev = $("#concRev");
  rev.classList.remove("is-swap"); void rev.offsetWidth; rev.classList.add("is-swap");
  const hasBa = !!(d.before && d.after);
  rev.classList.remove("conc__rev--single");
  rev.classList.toggle("conc__rev--none", !hasBa); /* Owner 11.09.: B/A bleibt in den Karten */
  if (hasBa){ $("#concBefore").src = d.before; $("#concAfter").src = d.after; }
  $("#concAfterLbl").textContent = d.weeks ? `Week ${d.weeks}` : "After";
  $("#concStars").innerHTML = +d.rating ? stars(+d.rating, 15) : "";
  $("#concTitle").textContent = d.title || "";
  $("#concQ").textContent = d.body || "";
  $("#concNote").textContent = d.note || "";
  $("#concAv").textContent = (d.name || "· ·").split(/\s+/).map(s => s[0]).join("").replace(".","").slice(0,2).toUpperCase();
  $("#concName").textContent = d.name || "";
  $("#concWho").textContent = [d.loc, d.weeks ? `${d.weeks} weeks in` : ""].filter(Boolean).join(" · ");
  $("#concChip").textContent = d.plan || "";
  concBtns.forEach((tb, j) => tb.setAttribute("aria-selected", j === i));
}
concBtns.forEach((b, i) => b.addEventListener("click", () => showConcern(i)));
if (concBtns.length) showConcern(ANGLE ? Math.max(0, concBtns.findIndex(b => b.textContent.trim() === ANGLE.tab)) : 0);

/* --- Eignung: Haut-Zeile nur in der Haar+Haut-Variante ------------------------- */
if (hairOnly) $$("#fitYes li").forEach(li => { if (/skin/i.test(li.textContent)) li.remove(); });

/* --- Passt-es-Pruefer --------------------------------------------------------- */
const fitHost = $("#fitTypes"), fitBtns = $$(".fitcheck__type", fitHost);
function showFit(i){
  const b = fitBtns[i]; if (!b) return; const d = b.dataset;
  $("#fitVerdict").innerHTML = `${d.img ? `<img src="${esc(d.img)}" alt="${esc(d.name)} shower with the filter fitted" loading="lazy">` : ""}<div><b>${esc(d.name)}</b><p>${esc(d.verdict)}</p></div>`;
  fitBtns.forEach((x, j) => x.setAttribute("aria-selected", j === i));
}
fitBtns.forEach((b, i) => b.addEventListener("click", () => showFit(i)));
if (fitBtns.length) showFit(0);

/* --- Reveal --------------------------------------------------------------- */
if ("IntersectionObserver" in window){
  const io = new IntersectionObserver(es => es.forEach(e => {
    if (e.isIntersecting){ e.target.classList.add("is-in"); io.unobserve(e.target); }
  }), { rootMargin:"0px 0px -12% 0px" });
  $$(".reveal").forEach(n => io.observe(n));
} else {
  $$(".reveal").forEach(n => n.classList.add("is-in"));
}
})();
